var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Button, Card, Container, Dimmer, Header, Icon, Segment } from 'semantic-ui-react';
import { useRequireAccessToken } from '~/Application/useRequireAccessToken';
import { ReportRoute } from '~/Application/routes';
import { useStore } from '~/Application/Store';
import { ErrorConsumer } from '~/ErrorHandler';
import * as Impersonate from '~/Impersonate';
import { ReportCard } from '~/ReportCard';
import { ErrorAlert, Placeholder } from '~/UI';
var parse = function (reports) {
    return reports.map(function (report) { return (__assign(__assign({}, report.reportInfo), { id: report.id, name: report.name })); });
};
var AddCustomReportCard = function () { return (<Card>
		<Card.Content>
			<Card.Header>
				<i>Přidat můj report dle mé šablony od Cogvio (XLSX formát</i>
			</Card.Header>
		</Card.Content>
		<Button attached primary onClick={function () {
        // eslint-disable-next-line no-alert
        alert('Přidáním reportu spustíte průvodce, který Vám umožní nahrát Váš standardní report ve formátu XLSX, který bude sloužit jako podkladová šablona pro vytvoření reportu na míru. Děkujeme za Váš zájem. Cogvio tým');
    }}>
			Přidat <Icon name='arrow right'/>
		</Button>
	</Card>); };
var ReportCards = function (_a) {
    var children = _a.children, reports = _a.reports;
    return (<Card.Group doubling stackable itemsPerRow={3}>
		{reports.map(function (report) { return (<ReportCard key={report.id} report={report} ReportLink={ReportRoute.Link}/>); })}
		{children}
	</Card.Group>);
};
ReportCards.displayName = 'Application.ReportCards';
export var Reports = function () {
    var _a, _b, _c, _d;
    useRequireAccessToken();
    var _e = useStore(), reports = _e.reports, customReports = _e.customReports;
    var predefinedReports = reports.map(function (response) { return ({ items: response.items.filter(function (report) { return !report.isCustom; }) }); });
    return (<Container>
			<ErrorConsumer>{function (error) { return <ErrorAlert>{error}</ErrorAlert>; }}</ErrorConsumer>
			<Impersonate.Panel />

			<Header>Reporty</Header>
			{reports.value === null && reports.isLoading ? <Placeholder /> : null}
			{reports.value === null && !reports.isLoading ? (<Segment placeholder>
					<Header icon>Nenalazen žádný report</Header>
				</Segment>) : null}

			{reports.value !== null ? (<Dimmer.Dimmable dimmed={reports.isLoading}>
					<div data-testid='reports'>
						<Dimmer inverted active={reports.isLoading}/>
						<ReportCards reports={(_b = (_a = predefinedReports.value) === null || _a === void 0 ? void 0 : _a.items.filter(function (report) { return report.id !== 'cz-dis13-swixx-dataview'; })) !== null && _b !== void 0 ? _b : []}>
							<AddCustomReportCard />
						</ReportCards>
					</div>
				</Dimmer.Dimmable>) : null}

			<Header>Moje reporty</Header>
			{customReports.value === null && customReports.isLoading ? <Placeholder /> : null}
			{customReports.value === null && !customReports.isLoading ? (<Segment placeholder>
					<Header icon>Nenalezen žádný report</Header>
				</Segment>) : null}

			{customReports.value !== null ? (<Dimmer.Dimmable dimmed={customReports.isLoading}>
					<div data-testid='custom-reports'>
						<Dimmer inverted active={customReports.isLoading}/>
						<ReportCards reports={parse((_d = (_c = customReports.value) === null || _c === void 0 ? void 0 : _c.items) !== null && _d !== void 0 ? _d : [])}/>
					</div>
				</Dimmer.Dimmable>) : null}
		</Container>);
};
Reports.displayName = 'Application.Reports';
